export enum CostType {
  None = 0,
  Monthlyfee = 1,
  OnceOffFee = 2,
}